import { render, staticRenderFns } from "./WithdrawRecordItem.vue?vue&type=template&id=757a3c22&scoped=true&"
import script from "./WithdrawRecordItem.vue?vue&type=script&lang=js&"
export * from "./WithdrawRecordItem.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawRecordItem.vue?vue&type=style&index=0&id=757a3c22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757a3c22",
  null
  
)

export default component.exports